import React from "react";
import { Separator } from "src/components/ui/Separator";

import "./BlogSection.scss";

interface ContentBlock {
  title: string;
  highlight: string;
  description: string;
}

const contentBlocks: ContentBlock[] = [
  {
    title: "We are ",
    highlight: "commited.",
    description:
      "Conversion angel investor entrepreneur first mover advantage. Handshake infographic mass market crowdfunding iteration.",
  },
  {
    title: "We are ",
    highlight: "responsible.",
    description:
      "Mass market iPhone buzz conversion analytics stock iteration responsive web design user experience business plan handshake. Return on investment seed round MVP backing supply chain.",
  },
  {
    title: "We aim for ",
    highlight: "progress.",
    description:
      "Bootstrapping rockstar first mover advantage business model canvas alpha deployment launch party beta facebook metrics gamification growth hacking customer focus.",
  },
];

const BlogSection = () => {
  return (
    <section className="blog-section">
      <div className="blog-section__container">
        <div className="blog-section__header">
          <div className="blog-section__subtitle">Our Blog</div>

          <h2 className="blog-section__title">
            Value proposition accelerator product management venture
          </h2>
        </div>

        <Separator className="blog-section__separator" />

        <div className="blog-section__content">
          {contentBlocks.map((block, index) => (
            <div key={index} className="blog-section__block">
              <div className="blog-section__block-title-container">
                <h3 className="blog-section__block-title">
                  <span className="blog-section__title-text">
                    {block.title}
                  </span>
                  <span className="blog-section__highlight-text">
                    {block.highlight}
                  </span>
                </h3>
              </div>

              <div className="blog-section__block-description-container">
                <p className="blog-section__block-description">
                  {block.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
